export default __webpack_public_path__ + "static/media/Osyte-Logo-02.21aa37c4.svg";